// extracted by mini-css-extract-plugin
module.exports = {"main_modal":"Modal_main_modal__AdF-O","main_modal__container":"Modal_main_modal__container__3deuC","main_modal__close_btn":"Modal_main_modal__close_btn__3uoaE"};